// 購物車頁小整理，全部透過同一個 MutationObserver 迴圈修正（因為這些區塊都會被 Alpine/AKO 自己的 script 重新渲染，
// 只做一次會在之後被復原）：
// 1) 把「我們接受」付款方式圖示區塊搬進結帳按鈕同一個 flex 容器裡，搪配 order 達到「總計 → 結帳 → 付款圖示 → AKO」。
// 2) 把總金額文字合併進結帳按鈕裡（「結帳 | $1,080.00 TWD」）。
// 3) AKO 「運送方式」標題文字改成「⇩ 選擇您的配送方式 ⇩」（颜色/置中由 CSS 控制）。
// 4) 「您已節省 $xxx TWD！」那一列改成「折扣」（左）/「-$xxx」（右）。
// 5) 加購區塊（cart-upsell 區段）的英文默認標題「You'll love this too」改成中文。
// 6) 結帳按鈕在尚未選擇超商時，外觀保持原本的「看起來淺色/不能按」樣子，但黙黙把它改成真的可以按，
//    按下去會彈一個「請選擇您的配送方式」提示，並自動滾到 AKO 選擇器，避免使用者以為按鈕壞了。
//    → 是否「準備好」完全看 AKO 自己設的 opacity（我們從不寫 opacity，只拿掉 disabled 跟 pointer-events:none，
//    避免自己改 disabled/style 觸發自己的 MutationObserver、形成回饏把刚設好的狀態写歪。
//
// 注意：AKO 超商選擇器、總金額、折扣金額都會因為購物車內容變化而重新渲染，所以不能只做一次。每個函式都寫成
// idempotent（已經正確就什麼都不做），找不到元素也不會報錯。

function vitaverseEnsureCartPaymentIconsPlacement() {
  var fc = document.querySelector('.form-checkout');
  var btn = document.getElementById('checkout-submit');
  if (!fc || !btn) return;
  var wrap = btn.parentElement;
  var col = fc.parentElement;
  if (!wrap || !col) return;

  var paymentBlock = null;
  Array.prototype.forEach.call(col.children, function (child) {
    if (child !== fc && child.querySelector && child.querySelector('.icon-payment')) {
      paymentBlock = child;
    }
  });
  if (!paymentBlock) {
    var ul = fc.querySelector('.icon-payment');
    if (ul) {
      var candidate = ul.parentElement;
      if (candidate && candidate !== wrap) paymentBlock = candidate;
    }
  }
  if (!paymentBlock) return;

  if (paymentBlock.parentElement !== wrap || paymentBlock.nextElementSibling) {
    paymentBlock.style.order = '2';
    wrap.appendChild(paymentBlock);
  }
}

function vitaverseSyncCheckoutButtonTotal() {
  var jsContents = document.getElementById('js-contents');
  var btn = document.getElementById('checkout-submit');
  if (!jsContents || !btn) return;
  var totalP = jsContents.querySelector('div.flex > p.h4.ml-auto');
  var labelSpan = btn.querySelector('.button-text');
  if (!totalP || !labelSpan) return;

  if (!labelSpan.dataset.baseLabel) {
    var current = labelSpan.textContent.trim();
    var sepIdx = current.indexOf(' | ');
    labelSpan.dataset.baseLabel = sepIdx > -1 ? current.slice(0, sepIdx) : current;
  }

  var amount = totalP.textContent.trim();
  if (!amount) return;
  var newText = labelSpan.dataset.baseLabel + ' | ' + amount;
  if (labelSpan.textContent.trim() !== newText) {
    labelSpan.textContent = newText;
  }
}

function vitaverseFixAkoHeading() {
  var h = document.querySelector('.ako-cvs-title');
  if (!h) return;
  var target = '⇩ 選擇您的配送方式 ⇩';
  if (h.textContent.trim() !== target) {
    h.textContent = target;
  }
}

function vitaverseRebuildDiscountRow() {
  var row = document.querySelector('#js-contents .flex.justify-between.items-end[role="status"]');
  if (!row) return;
  var p = row.querySelector('p');
  var s = row.querySelector('s');
  if (!p || !s) return;
  if (p.textContent.trim() === '折扣') return; // 已經改好了，不重複做
  var m = p.textContent.match(/\$[\d,]+\.\d{2}/);
  if (!m) return;
  p.textContent = '折扣';
  s.textContent = '-' + m[0];
}

function vitaverseFixUpsellHeading() {
  var section = document.querySelector('[id*="cart-upsell"]');
  if (!section) return;
  var h2 = section.querySelector('h2');
  if (!h2) return;
  var target = '多數人也選擇了 👇';
  if (h2.textContent.trim() !== target) {
    h2.textContent = target;
  }
}

function vitaverseShowCheckoutHint() {
  var existing = document.getElementById('vitaverse-checkout-hint');
  if (existing) existing.remove();

  var hint = document.createElement('div');
  hint.id = 'vitaverse-checkout-hint';
  hint.textContent = '請選擇您的配送方式';
  hint.style.cssText = 'position:fixed;left:50%;bottom:28px;transform:translateX(-50%);' +
    'background:#1f1f1f;color:#fff;padding:12px 22px;border-radius:999px;font-size:14px;' +
    'z-index:9999;box-shadow:0 4px 16px rgba(0,0,0,0.25);white-space:nowrap;pointer-events:none;' +
    'transition:opacity 0.3s ease;opacity:0;';
  document.body.appendChild(hint);
  requestAnimationFrame(function () { hint.style.opacity = '1'; });

  setTimeout(function () {
    hint.style.opacity = '0';
    setTimeout(function () { hint.remove(); }, 350);
  }, 2200);

  var akoSection = document.querySelector('.ako-cvs-section') || document.querySelector('.ako-cvs-title');
  if (akoSection && akoSection.scrollIntoView) {
    akoSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

function vitaverseFixCheckoutButtonUX() {
  var btn = document.getElementById('checkout-submit');
  if (!btn) return;
  var hasRealItems = !!document.querySelector('#main-cart-items tr.cart-item:not(.vitaverse-upsell-item)');
  if (!hasRealItems) return; // 購物車真的是空的，不要動它的 disabled 狀態

  // 只看 opacity 來判斷「AKO 認為還未準備好」，因為我們從不改 opacity，不會跟自己的 disabled/pointer-events 修改互相干擾。
  var opacity = parseFloat(getComputedStyle(btn).opacity);
  var notReady = isNaN(opacity) ? false : opacity < 0.99;
  btn.dataset.akoNotReady = notReady ? '1' : '0';

  if (btn.disabled) btn.removeAttribute('disabled');
  if (btn.style.pointerEvents === 'none') btn.style.pointerEvents = 'auto';

  if (!btn.dataset.vitaverseGuardBound) {
    btn.dataset.vitaverseGuardBound = '1';
    btn.addEventListener('click', function (e) {
      if (btn.dataset.akoNotReady === '1') {
        e.preventDefault();
        e.stopImmediatePropagation();
        vitaverseShowCheckoutHint();
      }
    }, true);
  }
}

function vitaverseCartCheckoutRefresh() {
  vitaverseEnsureCartPaymentIconsPlacement();
  vitaverseSyncCheckoutButtonTotal();
  vitaverseFixAkoHeading();
  vitaverseRebuildDiscountRow();
  vitaverseFixUpsellHeading();
  vitaverseFixCheckoutButtonUX();
}

function vitaverseInitCartCheckoutMover() {
  var root = document.body;
  vitaverseCartCheckoutRefresh();

  var observer = new MutationObserver(function () {
    vitaverseCartCheckoutRefresh();
  });
  observer.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'style'] });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', vitaverseInitCartCheckoutMover);
} else {
  vitaverseInitCartCheckoutMover();
}
